import React, { Component } from 'react';

export default class RenderStar extends Component {
  renderStar = star => {
    const starArr = [];

    for (let i = 1; i <= 5; i += 1) {
      if (i <= star) {
        starArr.push(1);
      } else {
        starArr.push(0);
      }
    }

    return starArr;
  };

  render() {
    const { number } = this.props;
    return (
      <>
        {this.renderStar(number) &&
          this.renderStar(number).length > 0 &&
          this.renderStar(number).map(x =>
            x === 1 ? (
              <img src="/static/vietnamTickets/images/star-vang.svg" alt="/star-vang" className='lazyload' width='auto' height="auto" />
            ) : (
              <img src="/static/vietnamTickets/images/star-xam.svg" alt="/star-xam" className='lazyload' width='auto' height="auto" />
            )
          )}
      </>
    );
  }
}
